<script lang="ts">
  import {getChainImage} from '@/modules/web3/images';
  import {network$, currentNetworkOptions$} from './streams';
  import SelectSearch from '../SelectSearch.svelte';

  export let choosedNetwork: any = {};
  $: updateChoosedNetwork($network$, $currentNetworkOptions$);

  function updateChoosedNetwork(network, networkOptions) {
    choosedNetwork = networkOptions.find((option) => option.value === network) || {};
  }

  function handleNetworkChange(e) {
    const {value = ''} = e.detail || {};
    network$.next(value);
  }
</script>

<span class="token-wrap">
  <SelectSearch options={$currentNetworkOptions$} value={$network$} on:change={handleNetworkChange}>
    <div slot="displayItem" class="df aic">
      {#if choosedNetwork.value}
        <img width="28px" height="28px" src={getChainImage(choosedNetwork.chainName)} alt="Coin" />
        <span class="ml8 f16 T1 b">{choosedNetwork.text}</span>
      {/if}
    </div>

    <div slot="item" let:option class=" df aic">
      <img width="28px" height="28px" src={getChainImage(option.chainName)} alt="Coin" />
      <span class="ml8 f14 T1">{option.text}</span>
    </div>
  </SelectSearch>
</span>
